import React from 'react';

const SIZE = {
  sm:  { wrap: 'w-7 h-7',  text: 'text-[10px]' },
  md:  { wrap: 'w-9 h-9',  text: 'text-[12px]' },
  lg:  { wrap: 'w-11 h-11', text: 'text-[14px]' },
};

const COLORS = [
  'bg-accent text-primary',
  'bg-primary text-white',
  'bg-teal-600 text-white',
  'bg-violet-600 text-white',
  'bg-emerald-600 text-white',
];

function colorForInitials(initials) {
  let n = 0;
  for (const c of initials) n += c.charCodeAt(0);
  return COLORS[n % COLORS.length];
}

export function Avatar({ initials, size = 'md', className = '' }) {
  const { wrap, text } = SIZE[size] || SIZE.md;
  const color = colorForInitials(initials || '?');
  return (
    <div className={`${wrap} rounded-full ${color} grid place-items-center font-semibold ${text} flex-shrink-0 ${className}`}>
      {initials}
    </div>
  );
}

export default Avatar;
